/* ── Complete the Look quick-view ── */
(function() {
  var modal   = document.getElementById('mb-ctl-modal');
  var closeBtn = document.getElementById('mb-ctl-modal-close');
  if (!modal) return;

  var modalImg   = document.getElementById('mb-ctl-modal-img');
  var modalName  = document.getElementById('mb-ctl-modal-name');
  var modalPrice = document.getElementById('mb-ctl-modal-price');
  var modalSizes = document.getElementById('mb-ctl-modal-sizes');
  var modalAtc   = document.getElementById('mb-ctl-modal-atc');
  var modalLink  = document.getElementById('mb-ctl-modal-link');
  var modalThumbs = document.getElementById('mb-ctl-modal-thumbs');

  var currentVariantId = null;

  function fmt(cents) { return '$' + (cents / 100).toFixed(2).replace(/\.00$/, ''); }

  function openModal(handle, title, price, url, img) {
    /* Set placeholder while loading */
    modalName.textContent = title;
    modalPrice.textContent = price;
    modalLink.href = url;
    modalImg.src = img;
    modalImg.alt = title;
    modalThumbs.innerHTML = '';
    modalSizes.innerHTML = '<p style="font-family:Montserrat,sans-serif;font-size:12px;color:#A69587;letter-spacing:.1em;text-transform:uppercase;">Loading...</p>';
    modalAtc.textContent = 'Select Size';
    modalAtc.disabled = true;
    currentVariantId = null;

    modal.classList.add('open');
    document.body.style.overflow = 'hidden';

    /* Fetch full product data */
    fetch('/products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(p) {
        /* Gallery */
        var imgs = p.images || [];
        if (imgs.length > 1) {
          modalThumbs.innerHTML = imgs.slice(0, 5).map(function(src, i) {
            return '<button class="mb-ctl-mt' + (i === 0 ? ' active' : '') + '" data-src="' + src + '" style="background-image:url(' + src.replace(/(\.[a-z]+)(\?|$)/, '_120x160_crop_center$1$2') + ')"></button>';
          }).join('');
          modalThumbs.querySelectorAll('.mb-ctl-mt').forEach(function(btn) {
            btn.addEventListener('click', function() {
              modalImg.src = btn.dataset.src;
              modalThumbs.querySelectorAll('.mb-ctl-mt').forEach(function(b) { b.classList.remove('active'); });
              btn.classList.add('active');
            });
          });
        }
        if (imgs[0]) modalImg.src = imgs[0];

        /* Size options */
        var sizeOpt = p.options.find(function(o) { return /size|talla/i.test(o.name); });
        if (!sizeOpt) {
          /* Single variant */
          currentVariantId = p.variants[0] && p.variants[0].id;
          modalSizes.innerHTML = '';
          modalAtc.textContent = 'Add to Bag';
          modalAtc.disabled = false;
          return;
        }

        var sizeIdx = p.options.indexOf(sizeOpt);
        var sizesHtml = sizeOpt.values.map(function(val) {
          var available = p.variants.some(function(v) { return v.options[sizeIdx] === val && v.available; });
          return '<button class="mb-ctl-sz' + (available ? '' : ' sold') + '" data-size="' + val + '" data-size-idx="' + sizeIdx + '"' + (available ? '' : ' disabled') + '>' + val + '</button>';
        }).join('');
        modalSizes.innerHTML = '<p class="mb-ctl-sz-label">Size</p>' + sizesHtml;

        modalSizes.querySelectorAll('.mb-ctl-sz:not(.sold)').forEach(function(btn) {
          btn.addEventListener('click', function() {
            modalSizes.querySelectorAll('.mb-ctl-sz').forEach(function(b) { b.classList.remove('active'); });
            btn.classList.add('active');
            var size = btn.dataset.size;
            var idx = parseInt(btn.dataset.sizeIdx);
            var variant = p.variants.find(function(v) { return v.options[idx] === size; });
            currentVariantId = variant ? variant.id : null;
            modalAtc.textContent = 'Add to Bag';
            modalAtc.disabled = !currentVariantId;
          });
        });
      })
      .catch(function() {
        modalSizes.innerHTML = '';
      });
  }

  /* ATC from modal */
  if (modalAtc) {
    modalAtc.addEventListener('click', function() {
      if (!currentVariantId || modalAtc.disabled) return;
      modalAtc.textContent = 'Adding…';
      modalAtc.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: currentVariantId, quantity: 1 })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        modalAtc.textContent = '✓ Added';
        setTimeout(function() {
          closeModal();
          if (window.mbOpenCart) window.mbOpenCart();
          fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
            document.querySelectorAll('.mb-cart-count,[data-cart-count]').forEach(function(el) { el.textContent = cart.item_count; });
          });
        }, 600);
      })
      .catch(function() {
        modalAtc.textContent = 'Add to Bag';
        modalAtc.disabled = false;
      });
    });
  }

  function closeModal() {
    modal.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  modal.addEventListener('click', function(e) { if (e.target === modal) closeModal(); });
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeModal(); });

  /* Wire up card buttons (image click or + button) */
  document.querySelectorAll('.mb-ctl-card-btn').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var card = btn.closest('.mb-ctl-card');
      if (!card) return;
      openModal(card.dataset.handle, card.dataset.title, card.dataset.price, card.dataset.url, card.dataset.img);
    });
  });
})();
